import React from 'react';
import type { WizardStepProps } from '../types';
import { FreeTextStep } from './FreeTextStep';

export const StepProud = (props: WizardStepProps) => <FreeTextStep copyKey="unusual_way_wizard.proud" {...props} />;
